import Vue from 'vue'
import Router from 'vue-router'

/**
 * 重写路由的push方法;解决重复点击同一个路由报错问题
 */
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
};

Vue.use(Router);

const router = new Router({
  // 跳转页面置顶
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },

  // mode: 'history',
  routes: [
    {
      path: '/',
      components: {
        // default: () => import('@/views/index/Index'),
        pc: () => import('@/views/index/Index'),
        m:() => import('@/views/index/mb_index'),
      },
    },
    {
      path: '/Abous_us',
      name: 'Abous_us',
      component: () => import('@/views/index/Abous_us'),
    },
    {
      path: '/products',
      name: 'Products',
      component: () => import('@/views/product/ProductList'),
    },
    {
      path: '/productsDetail/:id',
      name: 'ProductDetail',
      component: () => import('@/views/product/ProductDetail'),
    },
    {
      path: '/contact_us',
      name: 'contact_us',
      component: () => import('@/views/contact_us/contact_us'),
    },

    // {
    //   path: '/',
    //   name: 'index',
    //   component: () => import('@/views/index/Index'),
    // },

    // {
    //   path: '/index',
    //   name: 'index',
    //   redirect: '/index/house',
    //   component: () => import('@/views/index/Index'),
    //   children: [
    //     {
    //       path: 'house',
    //       name: 'house',
    //       component: () => import('@/views/index/indexHouse/IndexHouse'),
    //     },
    //     {
    //       path: 'process',
    //       name: 'process',
    //       component: () => import('@/views/index/process/Process')
    //     }
    //   ]
    // },
    /*{
      path: '/home',
      name: 'Home',
      component: () => import('@/views/home/Home'),
      meta: {title: '自述文件'},
      children: [
        {
          path: '/dashboard',
          component: () => import('@/views/dashboard/Dashboard'),
          meta: {title: '系统首页'}
        },
        {
          path: '/account',
          component: () => import('@/views/account/Account'),
          meta: {title: 'sidebar.accountDetails'} //账目明细
        },
        {
          path: '/billing',
          component: () => import('@/views/billing/BillingDetails'),
          meta: {title: 'sidebar.billingDetails'} //消费明细
        },
        {
          path: '/info',
          component: () => import('@/views/extra/Extra'),
          meta: {title: 'sidebar.personalInformation'} //个人中心
        },
        {
          path: '/chanpass',
          component: () => import('@/views/extra/Chanpass'),
          meta: { title: 'sidebar.changePassword' } //修改密码
        },
        {
          path: '/earnings',
          component: () => import('@/views/earnings/Earnings'),
          meta: {title: 'sidebar.earnings'}  //我的推广
        },
        {
          path:'/payout',
          component:()=>import('@/views/payout/Payout'),
          meta:{title:'sidebar.payoutRequests'}  //提现申请
        },
        {
          path:'/payout_list',
          component:()=>import('@/views/payout_list/PayoutList'),
          meta:{title:'sidebar.payoutList'}  //提现列表
        },
        {
          path: '/about',
          component: () => import('@/views/author/Author'),
          meta: {title: 'sidebar.about'}  //关于
        }
      ]
    },*/
    /*{
      path:'/login',
      name:'Login',
      component:()=>import('@/views/login/login')
    },*/
    /*{
      path:'/register',
      name:'Register',
      component:()=>import('@/views/register/Register')
    }*/
  ]
});

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
/*router.beforeEach((to, from, next) => {
  if (to.path === '/login' || to.path === '/register' || to.path === '/indexmain' || to.path==='/index/house' || to.path==='/index/process') {
    next();
  } else {
    let token = localStorage.getItem('access_token');
    // console.log(token)
    if (token === null || token === '') {
      next('/login');
    } else {
      next();
    }
  }
});*/
export default router
